<template>
  <div>
    <info-text i18n="integrations.helper.budget.introduction.create" />
    <va-create-layout>
      <budgets-form :item="item" />
    </va-create-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
export default {
  components: { InfoText },
  props: ["title", "item"]
};
</script>
